export const SUBSCRIPTION_TABS = { subscription: 'subscription', billingHistory: 'billing-history' }

export const BILLING_CYCLE = { month: 1, year: 12, infinite: -1 }

export const BILLING_CYCLE_TYPE = { year: 'YEAR', month: 'MONTH', day: 'DAY' }

export const ORDER_STATUSES = ['PENDING_APPROVAL', 'PAYMENT_AUTHORIZED', 'COMPLETE']

export const PAYMENT_METHOD_CODES = { FREE: 'FREE' }

export const PRODUCT_NAMES = {
    SMALL: 'Small',
    MEDIUM: 'Medium',
    LARGE: 'Large',
}
